module.exports = __webpack_public_path__ + "media/assets/icons/chevron-left-white-01fa8926659e590de374ff1f64e2c985.svg";